import { Flex, Typography } from 'antd';
import React from 'react'
import { ReactComponent as EmailIcon } from '../../../../assets/images/global-icons/email_checkmark.svg';
import  './CheckEmailModal.scss';

interface CheckEmailModalProps {
  text: string;
  onResend: () => void; 
}

export const CheckEmailModal: React.FC<CheckEmailModalProps> = ({ text, onResend }) => {
  return (
    <Flex vertical align="center" className="CheckEmail__body__confirmation">
      <EmailIcon className="CheckEmail__body__confirmation__icon" />
      <Typography.Title level={4} className="CheckEmail__body__confirmation__title">
        Check your email
      </Typography.Title>
      <Typography.Text className="CheckEmail__body__confirmation__text">{text}</Typography.Text>
      <Typography.Text className="CheckEmail__body__confirmation__note">
        Didn’t receive an email?{' '}
        <span className="CheckEmail__body__confirmation__resend" onClick={onResend}>
          Resend
        </span>
      </Typography.Text>
    </Flex>
  );
};
